// extracted by mini-css-extract-plugin
export default {"inputField":"IllustrationQuestion__inputField___Xxtrb","selfReflection":"IllustrationQuestion__selfReflection___PME8S"};